// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1XCtr","title":"Info_title__2htvO","selects":"Info_selects__kKOnh","requiredAsterisk":"Info_requiredAsterisk__2bkS9"};